<template>
	<el-container id="guide">
		<div v-loading="loading">
			<div class="guide material">
				<div class="titBox" style="margin-top:0;">
					<p class="tit">资料汇总</p>
					<div class="fl label_category">
						<div v-for="(item) in tag_list" :key="item.key" @click="this_color(item.id)" :style="tag_id==item.id?item.style:''">{{item.title}}</div>
					</div>
                    <div class="inp">
                        <i class="el-icon-search"></i>
                        <input type="text" placeholder="搜索" @input="getguide(true)" v-model="params.title">
                    </div>
				</div>
                <div v-if="guideList.length!=0">
                    <div class="guide_text">
        	            <p @click="guide_text(item)" class="guide_text_p material_p" v-for="(item,i) in guideList" :key="i">
                            <span class="material_tag" :style="'border-color:'+item.tag.color+';color:'+item.tag.color+';'">{{item.tag.title}}</span>
                            <span class="material_title">{{item.title}}</span>
                            <i class="iconfont iconfont_right" :style="'color: '+item.tag.color+';'">{{item.file_ext==1?'&#xe856;':'&#xe606;'}}</i>
                        </p>
        	        </div>
                </div>
        	    <div class="nodata" v-else>
			    	<img style="width: 500px;" :src="global.oss_website+'/wap/images/no_data_img.jpg'">
			    	<p>暂时没有找到你要的资料<span>，点击<el-link v-if="empty_bol" type="primary" :underline="false" @click="empty()">返回</el-link></span></p>
			    </div>

        	</div>
			
		</div>
        <div class="paging" v-if="total!=0">
			<el-pagination
    		  @size-change="handleSizeChange"
    		  @current-change="handleCurrentChange"
    		  :current-page="params.page"
    		  :page-sizes="[10, 20, 30, 40]"
    		  :page-size="params.limit"
    		  layout="total, sizes, prev, pager, next, jumper"
    		  :total="total">
    		</el-pagination>
		</div>
	</el-container>
</template>

<script>
export default {
	name: 'material'
	,data () {
		return {
            guideList:[],
			loading:false,
			// currentPage4:1,
			params:{
				page:1,
				limit :10,
                title:''
			},
			total:0,
            empty_bol:false,
			tag_list:[],		//标签列表
			tag_id:0,
		}
	}
	,mounted:function(){
		// console.log(this.$route.query.page);
		this.getguide(true,true)
		this.get_tag_list()
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
		// pageSize 改变时会触发
		handleSizeChange(data){
			// console.log(111);
			// console.log(data);
			this.params.limit  = data
			this.getguide()
		},
		// currentPage 改变时会触发
		handleCurrentChange(data){
			// console.log(222);
			// console.log(data);
			this.params.page = data
			this.getguide()
		},
		// 跳转
		guide_text(data){
			// console.log(data);
			if (data.file_ext==2) {
				this.$router.push({
					name:'material_play',
					query:{
						material_id:data.id,
            	        title:data.title,
						mould_id:this.$route.query.mould_id
						// page:this.$route.query.page
					}
				});
			}else{
				window.open(this.global.oss_website + data.file_url)
			}
		},
		//列表
		async getguide(bol,empty){
            if (bol) {
                this.params.page = 1
            }
            if (!empty) {
                this.empty_bol = true
            }
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			this.bijiloading = true
			// this.params.news_type = "2"
            // console.log(this.$route.query);
			this.params.mould_id = this.$route.query.mould_id   //教学计划id
			this.params.tag_id = this.tag_id   //标签id
			await this.$ajax.get(serverSrc + qianzui + "/material/material_list",{params:this.params})
			.then((res)=>{
				this.guideList = res.data.data.data
				this.total = res.data.data.total
				this.loading = false
				// console.log(res);
				// console.log(res.list.data);
			})
			.catch(_ => {
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~');
			});
		},
		//切换标签
        this_color(i){
            if (i!=this.tag_id) {
                this.tag_id = i
                this.getguide(true)
            }
        },
        //返回清空
        empty(){
            this.params.title = ''
            this.params.page = 1
            this.getguide()
        },
		//获取标签列表
        get_tag_list(){
			let token=this.$cookies.get("token")
			// console.log(this.global.serverSrc);
			// console.log(this.global.qianzui);
            this.$ajax.get(this.global.serverSrc + this.global.qianzui + '/material/tag_list',{params:{
				mould_id:this.params.mould_id
			}})
            .then((res) => {
                this.tag_list = res.data.data
                this.tag_list.map((v,i)=>{
                    v.key = 'tag_'+v.id
                    v.style = 'color:#fff;background-color:'+v.color+';border-color:'+v.color
                })
                this.tag_list.unshift({
                    color: "#376efd"
                    ,id: 0
                    ,title: "全部"
                    ,key:'tag_0'
                    ,style:'color:#fff;background-color:#376efd;border-color: #376efd;'
                })
                // console.log(res);
            })
        },
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/info/material.vue